(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"] && !Shopify.designMode) return;
  try {
    

document.addEventListener('DOMContentLoaded', function () {

  function updateTdaCartCount(count) {
    const cartCount = document.getElementById('tda-cart-count');

    if (!cartCount) return;

    const itemCount = Number(count) || 0;

    cartCount.textContent =
      itemCount > 99
        ? '99+'
        : itemCount > 0
          ? itemCount
          : '';
  }

  document.addEventListener('cart:updated', function (event) {
    const count =
      event &&
      event.detail &&
      typeof event.detail.item_count !== 'undefined'
        ? event.detail.item_count
        : 0;

    updateTdaCartCount(count);
  });

});


  } catch(e) { console.error(e); }
})();
})();
